import ArrowWithVector from './ArrowWithVector';

export default ArrowWithVector;
